import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Actions, ofActionSuccessful, Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';

import { ReactiveComponent } from 'src/app/components/shared/reactive-component';
import {
  CreditCardProcessingType,
  GatewayTransactionModalView
} from 'src/app/models';
import {
  CancelGatewayTransaction,
  CancelGatewayTransactionSuccess,
  MakePaymentFailed,
  OnGatewayTransactionError,
  OnGatewayTransactionSuccess,
  OnRetryGatewayTransaction
} from 'src/app/store/payment/payment.action';
import { LocationSelectors } from 'src/app/store/location/location.selectors';

export interface IGatewayTransactionModal {
  isManualCardEntry: boolean;
}

@Component({
  selector: 'pos-gateway-transaction',
  templateUrl: './gateway-transaction.modal.html',
  styleUrls: ['./gateway-transaction.modal.scss']
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class GatewayTransactionModal extends ReactiveComponent {
  @Input() isManualCardEntry = false;

  @Select(LocationSelectors.getCreditCardProcessingType)
  readonly creditCardProcessingType$: Observable<CreditCardProcessingType>;

  view: GatewayTransactionModalView = GatewayTransactionModalView.IN_PROGRESS;
  gatewayError: { message: string; cmdStatus?: string } = null;

  constructor(
    public readonly modalCtrl: ModalController,
    private readonly actions$: Actions,
    private readonly store: Store
  ) {
    super();
  }

  *onSubscribe() {
    yield this.actions$
      .pipe(ofActionSuccessful(OnGatewayTransactionSuccess))
      .subscribe(() => (this.view = GatewayTransactionModalView.SUCCESS));

    yield this.actions$
      .pipe(
        ofActionSuccessful(
          MakePaymentFailed, // DEF-5964 MakePaymentFailed is the wrapper of MakePaymentError which is missing in the code
          OnGatewayTransactionError,
          CancelGatewayTransactionSuccess
        )
      )
      .subscribe((action) => {
        this.view = GatewayTransactionModalView.ERROR;
        this.gatewayError =
          'gatewayError' in action
            ? { message: action.gatewayError, cmdStatus: action.cmdStatus }
            : null;
      });
  }

  onRetry() {
    this.store.dispatch(new OnRetryGatewayTransaction());
    this.view = GatewayTransactionModalView.IN_PROGRESS;
  }

  onCancelTransaction() {
    this.store.dispatch(new CancelGatewayTransaction());
  }
}
